import React, { useEffect, useState } from 'react';
import axios from 'axios';
import AdminLayout from '../Componets/AdminLayout';
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function ResultDasboard() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const perPage = 24; // Number of records per page
  const [count, setCount] = useState(0);

  useEffect(() => {
    const role = localStorage.getItem('role');
    if (role !== 'ADMIN') {
      navigate('/');
    }
  }, [navigate]);

  useEffect(() => {
    if (searchQuery) {
      searchExams(searchQuery);
    } else {
      fetchExams(currentPage);
    }
  }, [currentPage, searchQuery]);

  // Function to fetch exams with pagination
  const fetchExams = async (page) => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${apiUrl}/api/exam?skip=${(page - 1) * perPage}&take=${perPage}`,
        {
          headers: {
            Authorization: `${token}`,
          },
        }
      );
      setRecords(response.data.exams);
      setTotalPages(Math.ceil(response.data.count / perPage)); // Using the count field from the API response
      setCount(response.data.count);
    } catch (error) {
      error.response?.status === 401 && navigate('/');
      console.error('Error fetching exams:', error);
      toast.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  // Function to search exams by name
  const searchExams = async (query) => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${apiUrl}/api/exam/search/name`,
        { name: query },
        {
          headers: {
            Authorization: ` ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      setRecords(response.data.exams);
      setTotalPages(1); // Assume search results fit in one page
    } catch (error) {
      error.response?.status === 401 && navigate('/');
    } finally {
      setLoading(false);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1); // Reset to the first page on new search
  };

  return (
    <>
      <div>
        <AdminLayout ac8="active">
          <main id="main" className="main">
            <div className="pagetitle">
              <nav>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/AdminHome">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Exams ({count})</li>
                </ol>
              </nav>
            </div>
            <div className="d-flex justify-content-between">
              <div className="bd-highlight">
                <div className="exam-details-search-bar d-inline-flex p-2 pb-0">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control"
                    value={searchQuery}
                    onChange={handleSearchChange}
                  />
                </div>
              </div>
              <div className="bd-highlight"></div>
              <div className="bd-highlight mt-3">
                <div className="pagination d-flex col-12 justify-content-end">
                  <span>
                    Page{' '}
                    <span className="badge rounded-pill bg-secondary">
                      {currentPage}
                    </span>{' '}
                    of{' '}
                    <span className="badge rounded-pill bg-dark">
                      {totalPages}
                    </span>
                  </span>
                  <button
                    type="button"
                    className="btn btn-primary btn-sm mx-1 px-3 ms-4"
                    onClick={handlePreviousPage}
                    disabled={currentPage === 1}
                  >
                    <i className="bi bi-chevron-double-left"></i>
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary btn-sm mx-1 px-3"
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                  >
                    <i className="bi bi-chevron-double-right"></i>
                  </button>
                </div>
              </div>
            </div>
            <hr className="border border-1 border-dark" />
            <div className="exam-details-image-container ">
              {loading ? (
                <p>Loading...</p>
              ) : (
                <div className="exam-details-grid-container  ">
                  {records.map((exam, index) => (
                    <div key={index}>
                      <div
                        className="exam-details-image-item mx-2"
                        style={{ cursor: 'pointer' }}
                        onClick={() =>
                          navigate('/ListResult', {
                            state: { examId: exam.id, examName: exam.name },
                          })
                        }
                      >
                        <img
                          src={
                            'https://cdn-icons-png.freepik.com/512/9913/9913576.png?ga=GA1.1.701570569.1719990316'
                          }
                          alt={exam.name}
                          style={{
                            width: '100px',
                            height: '100px',
                            objectFit: 'cover',
                            margin: 'auto',
                          }}
                        />
                        <p style={{ fontSize: '13px' }}>{exam.name}</p>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <ToastContainer position="top-center" style={{ width: 'auto' }} />
          </main>
        </AdminLayout>
      </div>
    </>
  );
}
